import Cookies from 'universal-cookie';

const COOKIE_MAX_AGE = 86400;

export class CookieHelper {
    constructor(initData, isStandalone) {
        if (!this.cookies) {
            this.cookies = new Cookies();
        }
        if (isStandalone) {
            this.cookiePrefix = 'odeza_stn_chat_' + hashCode(initData) + '_';
        } else {
            this.cookiePrefix = 'odeza_chat_' + hashCode(initData) + '_';
        }
    }

    getConnectKeys() {
        let savedConnectKeys;
        if (this.cookies) {
            savedConnectKeys = this.cookies.get(this.cookiePrefix + 'connectKeys');
            try {
                if (typeof savedConnectKeys !== 'object') {
                    savedConnectKeys = JSON.parse(savedConnectKeys);
                }
            } catch (e) {
            }
        }
        return savedConnectKeys;
    }

    saveConnectKeys(keys) {
        try {
            if (typeof keys === 'object') {
                keys = JSON.stringify(keys);
            }
        } catch (e) {
        }
        this.cookies.set(this.cookiePrefix + 'connectKeys',
            keys,
            {path: '/', sameSite: 'strict', maxAge: COOKIE_MAX_AGE}
        );
    }

    saveUserName(name) {
        this.cookies.set(this.cookiePrefix + 'username',
            name,
            {path: '/', sameSite: 'strict', maxAge: COOKIE_MAX_AGE}
        );
    }

    deleteCookies() {
        this.cookies.remove(this.cookiePrefix + 'username');
        this.cookies.remove(this.cookiePrefix + 'customer');
        this.cookies.remove(this.cookiePrefix + 'agreement');
        this.cookies.remove(this.cookiePrefix + 'connectKeys');
    }
}

export const hashCode = (data) => {
    let hash = 0, i, chr;
    if (data.length === 0) {
        return hash;
    }
    for (i = 0; i < data.length; i++) {
        chr = data.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash.toString(16);
}